import React from 'react';
import SectionForm from './SectionForm';
import {LanguageId} from '../../../models/utils/Languages';
import SectionConfiguration from '../../../models/form/SectionConfiguration';
import {ActionType} from '../types';
import {useParams} from 'react-router';
import {getSectionConfiguration} from '../Sections';

type Props = {
  defaultLanguage: LanguageId
  sections: SectionConfiguration[]
  onCreateUpdate: (action: ActionType, el?: SectionConfiguration) => void
}

interface SectionParams {
  id?: string
}

export default function SideSectionForm({
  defaultLanguage, sections, onCreateUpdate,
}: Props) {
  const {id} = useParams<SectionParams>();

  const section = getSectionConfiguration(id || 'new', sections)
  const title = section ? 'Edit a section' : 'Add a new section';

  return (
    <>
      <h2 className="font-bold text-2xl pb-2 flex justify-between">
        <span>{title}</span>
      </h2>
      <SectionForm configuration={section} defaultLanguage={defaultLanguage}
        onCreateUpdate={onCreateUpdate}
      />
    </>
  );
}
